import React from 'react';
import styles from './Header.less';

export default class Header extends React.Component {
	render() {
		const {children} = this.props;
		const {header: headerClass} = styles;

		return (
			<div>
				<h2 className={headerClass}>{children}</h2>
			</div>
		);
	}
}